/**
 * Em que aparelho e navegador o Live Gospel está aberto — decide qual passo a passo de
 * instalação o painel mostra primeiro. Puro (recebe o `navigator`), para testar sem DOM.
 */
export type DevicePlatform = 'android' | 'ios' | 'desktop';

type NavigatorLike = Pick<Navigator, 'userAgent'> & { maxTouchPoints?: number };

export function detectPlatform(nav: NavigatorLike): DevicePlatform {
  const ua = nav.userAgent;

  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  // O iPad com iPadOS 13+ se apresenta como Mac; a tela de toque o denuncia.
  if (/macintosh/i.test(ua) && (nav.maxTouchPoints ?? 0) > 1) return 'ios';

  return 'desktop';
}

/**
 * O Safari do iPhone/iPad (e não o Chrome, o Firefox ou o navegador embutido de outro
 * aplicativo, que também dizem "Safari" no user agent).
 */
export function isIosSafari(nav: NavigatorLike): boolean {
  const ua = nav.userAgent;

  return (
    detectPlatform(nav) === 'ios' &&
    /safari/i.test(ua) &&
    !/crios|fxios|edgios|opios|gsa\/|instagram|fban|fbav/i.test(ua)
  );
}

/** Aberto pelo ícone da tela inicial (o aplicativo instalado), e não numa aba. */
export function isStandalone(win: Window): boolean {
  const iosStandalone = (win.navigator as Navigator & { standalone?: boolean }).standalone === true;

  return iosStandalone || !!win.matchMedia?.('(display-mode: standalone)').matches;
}

export const PLATFORM_LABEL: Record<DevicePlatform, string> = {
  android: 'Android',
  ios: 'iPhone ou iPad',
  desktop: 'computador',
};
